import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './navigtaion-menu.scss';

const NavigationMenu = ({
  items,
  isPrimary,
  className = '',
}) => (
  <ul className={classNames(
    'nav-menu',
    { 'nav-menu--primary': isPrimary },
    className,
  )}
  >
    {items.map((item) => (
      <li className="nav-menu__item" key={item.href}>
        <a className="nav-menu__link" href={item.href}>{item.label}</a>
      </li>
    ))}
  </ul>
);

NavigationMenu.propTypes = {
  className: PropTypes.string,
  isPrimary: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
};

NavigationMenu.defaultProps = {
  isPrimary: false,
  className: undefined,
};

export default NavigationMenu;
